import { render, staticRenderFns } from "./SendOrderUpdateRecord.vue?vue&type=template&id=679681ac&scoped=true&"
import script from "./SendOrderUpdateRecord.vue?vue&type=script&lang=js&"
export * from "./SendOrderUpdateRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "679681ac",
  null
  
)

component.options.__file = "SendOrderUpdateRecord.vue"
export default component.exports